'use strict';

//let ortsgemeindeDaten = null;
//let ortsgemeindenGrid = null;
//let ortsgemeindenKontrollwerteInfo = null;
export function pageInit(sessionInfo) {
    
    let controlConfig = {
        position: 'top',
        hideEvent: 'mouseleave'
    };
    if (SurveyHooks.onConfigureControl) { SurveyHooks.onConfigureControl('tooltip', 'dxTooltip', controlConfig, null); }
    SurveyRuntime.tooltip = $('#erhebung-daten-grid-tooltip-container').dxTooltip(controlConfig).dxTooltip('instance');
    //console.log(SurveyRuntime.tooltip)
    if (CONFIG.useStandardHeader) {
        $("#common-head-title").html('Personalbestandserhebung <span class="highlight">' + new Date().getFullYear() + '</span> online');
        $("#common-head-info").html('Lade Daten...');
    }
    if (CONFIG.useStandardFooter) {
        $("#common-foot-logout").html('<a href="#" id="common-logout" title="Abmelden ohne zu speichern.">Logout</a>');
        $("#common-logout").on("click", function (e) { e.preventDefault(); SurveyTools.logout(true); });
    }
    if (SurveyHooks.onStarting) { SurveyHooks.onStarting() } 
    // Daten holen
    const url = new URL(window.CONFIG.serverApi + "/daten");
    const request = {
        cache: false,
        url: url,
        contentType: 'application/json',
        method: 'GET',
        headers: window.CONFIG.customHeaders,
        success: function (response) {
            initializeForm(response);
        },
        error: function (jqXHR) {
            $("#common-head-info").hide();
            if (SurveyHooks.onFetchDataError) {
                SurveyHooks.onFetchDataError(jqXHR);
            } else {
                SurveyTools.showErrorInPage(jqXHR);
            }
        }
    };
    $.ajax(request);
}
function initializeForm(erhebungsdatenResponse) {
    SurveyRuntime.surveyData = erhebungsdatenResponse;
    SurveyRuntime.currentSurvey = erhebungsdatenResponse.erhebungsdaten;
    CONFIG.memberStatusCode = erhebungsdatenResponse.mitgliedStatusCode;
    SurveyRuntime.useGridMode = !CONFIG.smallSurveyForGuests || CONFIG.memberStatusCode === 'M';

    const dates = {
        endeDatum: undefined,
        stichDatum: undefined
    }
    if (window.CONFIG.specialLogin === "neu") {
        dates.stichDatum = new Date(SurveyRuntime.currentSurvey.exBezugsdatum);
        dates.endeDatum = new Date(SurveyRuntime.currentSurvey.exEnde);
    } else {
        dates.stichDatum = new Date(erhebungsdatenResponse.jahr, 4, 31);
        dates.endeDatum = new Date(erhebungsdatenResponse.endeAngezeigt);
    }
    SurveyRuntime.mitgliedNummer = erhebungsdatenResponse.mitgliedNummer;
    if (CONFIG.useStandardHeader) {
        $("#common-head-title").html(`Personalbestandserhebung <span class "highlight">${erhebungsdatenResponse.jahr}</span> zum Stichtag ${dates.stichDatum.toLocaleDateString("de-de")}`);
        let msg = `für <span class="highlight">${erhebungsdatenResponse.mitgliedName ?? "n/a"}</span> (Mitgliedsnummer ${SurveyRuntime.mitgliedNummer ?? "n/a"})`;
        msg += `<br/>online (bis ${dates.endeDatum.toLocaleDateString("de-de")})`;
        $("#common-head-info").html(msg);
    }
    updateFooter();
    setupDeviationStuff(erhebungsdatenResponse);
    
    if (SurveyHooks.onDataLoaded) (SurveyHooks.onDataLoaded(erhebungsdatenResponse, dates))
    // if (erhebungsdatenResponse.erhebungOrtsgemeindedaten && erhebungsdatenResponse.erhebungOrtsgemeindedaten.length > 0) {
    //     ortsgemeindeDaten = erhebungsdatenResponse.erhebungOrtsgemeindedaten;
    // }
    $("#survey").css("display", "block");
    let controlConfig = {
        value: SurveyRuntime.currentSurvey.bearbeiter ?? "",
        inputAttr: { 'aria-label': 'vollständiger Name Bearbeiter:in' },
        maxLength: CONFIG.personResponsible.maxLength,
        onValueChanged(e) { SurveyRuntime.currentSurvey.bearbeiter = e.value; },
    };
    let controlValidatorConfig = {
        validationRules: [
            {
                type: 'required',
                message: 'Bitte geben Sie Ihren Namen an.'
            },
            {
                type: 'stringLength',
                min: 8,
                max: CONFIG.personResponsible.maxLength,
                message: `Bitte geben Sie mindestens 8 und höchstens ${CONFIG.personResponsible.maxLength} Zeichen für Ihren Namen an.`
            }
        ]
    };
    if (SurveyHooks.onConfigureControl) { SurveyHooks.onConfigureControl('Bearbeiter', 'dxTextBox', controlConfig, controlValidatorConfig); }
    SurveyRuntime.controls['Bearbeiter'] = $('#Bearbeiter').dxTextBox(controlConfig).dxValidator(controlValidatorConfig).dxTextBox("instance");

    controlConfig = {
        value: SurveyRuntime.currentSurvey.email ?? "",
        inputAttr: { 'aria-label': 'E-Mail-Adresse' },
        maxLength: CONFIG.email.maxLength,
        onValueChanged(e) { SurveyRuntime.currentSurvey.email = e.value; }
    };
    controlValidatorConfig = {
        validationRules: [
            {
                type: 'required',
                message: 'Bitte geben Sie eine E-Mail-Adresse für eventuelle Rückfragen an.'
            },
            {
                type: 'email',
                message: 'Bitte geben sie eine gültige E-Mail-Adresse an.'
            },
            {
                type: 'stringLength',
                max: CONFIG.email.maxLength,
                message: `Die E-Mail-Adresse ist zu lang. Maximal ${CONFIG.email.maxLength} Zeichen sind möglich.`
            }
        ]
    };
    if (SurveyHooks.onConfigureControl) { SurveyHooks.onConfigureControl('#Email', 'dxTextBox', controlConfig, controlValidatorConfig); }
    SurveyRuntime.controls['Email'] = $('#Email').dxTextBox(controlConfig).dxValidator(controlValidatorConfig).dxTextBox("instance");

    controlConfig = {
        value: SurveyRuntime.currentSurvey.telefon ?? "",
        inputAttr: { 'aria-label': 'Telefonnummer Bearbeiter:in für Rückfragen' },
        maxLength: CONFIG.telefon.maxLength,
        onValueChanged(e) { SurveyRuntime.currentSurvey.telefon = e.value; },
        onKeyDown(e) {
            const evt = e.event;
            if (evt.key === 'Tab' && !evt.ctrlKey && !evt.shiftKey && !evt.altKey && SurveyRuntime.grids.mainGrid) {
                const cell = SurveyRuntime.grids.mainGrid.grid.getCellElement(0, 'bs_Vollzeit');
                SurveyRuntime.grids.mainGrid.grid.focus(cell);
                SurveyRuntime.grids.mainGrid.grid.editCell(0, 'bs_Vollzeit');
            }
        }
    };
    controlValidatorConfig = {
        validationRules: [
            {
                type: 'required',
                message: 'Bitte geben Sie Ihre Telefonnummer für eventuelle Rückfragen an.'
            },
            {
                type: 'stringLength',
                min: 8,
                max: CONFIG.telefon.maxLength,
                message: `Bitte geben Sie mindestens 8 und höchstens ${CONFIG.telefon.maxLength} Zeichen für die Telefonnummer an.`
            }
        ]
    };
    if (SurveyHooks.onConfigureControl) { SurveyHooks.onConfigureControl('#Telefon', 'dxTextBox', controlConfig, controlValidatorConfig); }
    SurveyRuntime.controls['Telefon'] = $('#Telefon').dxTextBox(controlConfig).dxValidator(controlValidatorConfig).dxTextBox("instance");

    const prevYearTotal = SurveyRuntime.surveyData.erhebungsdatenVorjahr?.erhebungRows[CONFIG.surveyHelper.Erhebung_Info.totalRowPosition][CONFIG.surveyHelper.Erhebung_Info.totalColumnField]
    controlConfig = {
        value: prevYearTotal ?? "k.A.", 
        inputAttr: { 'aria-label': 'Gesamtzahl Beschäftigte aus Vorjahr' },
        onValueChanged(e) { },
        readOnly: true
    };
    controlValidatorConfig = null;
    if (SurveyHooks.onConfigureControl) { SurveyHooks.onConfigureControl('#GesamtVorjahr', 'dxTextBox', controlConfig, controlValidatorConfig); }
    SurveyRuntime.controls['GesamtVorjahr'] = $('#GesamtVorjahr').dxTextBox(controlConfig).dxTextBox("instance");

    $(SurveyRuntime.deviationReasonAreaId).hide();
    if (SurveyRuntime.deviationCheckEnabled) {
        let control = null;
        let div = $("#GrundAbweichung")
        controlValidatorConfig = {
            validationRules: [
                {
                    type: 'custom',
                    validationCallback: (e) => {
                        return existsRelevantDeviation() ? e.Value : true;
                    },
                    message: ` Bitte geben Sie den Grund dafür an.`
                },
                {
                    type: 'stringLength',
                    min: 8,
                    max: CONFIG.deviationReason.maxLength,
                    message: `Bitte geben Sie mindestens 8 und höchstens ${CONFIG.deviationReason.maxLength} Zeichen für den Grund der Abweichung an.`
                }
            ]
        }
        if (CONFIG.deviationReason.items) {
            controlConfig = {
                acceptCustomValue: CONFIG.deviationReason.acceptCustomValue,
                dataSource: CONFIG.deviationReason.items,
                value: SurveyRuntime.currentSurvey.grundAbweichung ?? "",
                onValueChanged(e) { SurveyRuntime.currentSurvey.grundAbweichung = e.value; manageDeviationReasonState(); },
                inputAttr: { 'aria-label': 'Grund für die erhebliche Abweichung der Beschäftigtenzahlen gegenüber den Werten des Vorjahrs' },
                maxLength: CONFIG.deviationReason.maxLength,
                placeholder: "Bitte wählen Sie den Grund aus"
            }
            if (SurveyHooks.onConfigureControl) { SurveyHooks.onConfigureControl('#GrundAbweichung', 'dxSelectBox', controlConfig, controlValidatorConfig); }
            control = div.dxSelectBox(controlConfig).dxSelectBox("instance");
        } else {
            // todo: Textbox
        }
        SurveyRuntime.controls['GrundAbweichung'] = control;
    }

    if (CONFIG.useNoEmployees) {
        controlValidatorConfig = null;
        controlConfig = {
            value: SurveyRuntime.currentSurvey.keineBeschaeftigten ?? false,
            onValueChanged: (e) => {
                SurveyRuntime.currentSurvey.keineBeschaeftigten = e.value;
                noEmployeesState(e.value);
            },
            text: "aktuell gibt es keine Beschäftigten"
        };
        if (SurveyHooks.onConfigureControl) { SurveyHooks.onConfigureControl('#keineBeschaeftigte', 'dxCheckBox', controlConfig, controlValidatorConfig); }
        SurveyRuntime.controls['keineBeschaeftigte'] = $("#keineBeschaeftigte").dxCheckBox(controlConfig).dxCheckBox("instance");
        CONFIG.noEmployeesAvailable = true;
        noEmployeesAvailable();
    }

    controlConfig = {};
    // Achtung: Property heißt hier anders als die Id der div
    if (SurveyHooks.onConfigureControl) { SurveyHooks.onConfigureControl('#survey-validation-custom', 'dxValidationSummary', controlConfig, undefined); }
    SurveyRuntime.controls.CustomValidationSummary = $('#survey-validation-custom').dxValidationSummary(controlConfig).dxValidationSummary("instance");

    // setup grid
    const columnDef = CONFIG.surveyHelper.Erhebung_DataColumnConfiguration();
    setupErhebungColumns(columnDef);
    if (SurveyRuntime.useGridMode) {
        const rows = SurveyRuntime.currentSurvey.erhebungRows;
        CONFIG.surveyHelper.Erhebung_PrepareRows(rows);
        rows.forEach((row) => {
            if (row.annotationId) {
                row.label += '<sup class="annotation">' + row.annotationId + '</sup>';
            }
        });
        const gridConfig = {
            dataSource: rows,
            keyExpr: 'rowTag',
            allowColumnResizing: false,
            allowColumnReordering: false,
            showBorders: true,
            showRowLines: true,
            showColumnLines: true,
            activeStateEnabled: true,
            rowAlternationEnabled: true,
            width: "100%",
            //height: "80vh",
            scrolling: {
                //mode: 'virtual',
                showScrollbar: 'always',
                useNative: true
            },
            sorting: { mode: "none" },
            paging: { enabled: false },
            keyboardNavigation: {
                editOnKeyPress: true,
                enabled: true,
                enterKeyAction: "moveFocus",
                enterKeyDirection: "row"
            },
            editing: {
                allowAdding: false,
                allowDeleting: false,
                allowUpdating: true,
                mode: "cell",
                selectTextOnEditStart: true
            },
            onEditingStart: function (e) {
                // prüfen, ob editiert werden kann; Summenspalten müssen wir hier nicht prüfen, weil die schon in der Spaltendefinition nicht editierbar gesetzt wurden 
                let rowTag = e.data.rowTag;
                if (CONFIG.surveyHelper.Erhebung_Info.sumRows.includes(rowTag)) {
                    e.cancel = true; // Summenzeile => kein Editieren
                    return;
                }
                let omitDef = CONFIG.surveyHelper.Erhebung_Info.omitRows.find(o => o.rowName === rowTag);
                if (omitDef) {
                    if (omitDef.columns.includes(e.column.dataField)) {
                        e.cancel = true; // "ausgelassene" Zelle  => kein Editieren
                        return;
                    }
                }
                SurveyRuntime.currentDataField = e.column.dataField;
            },
            onRowUpdated: function (e) {
                // Summen neu berechnen
                window.CONFIG.surveyHelper.Erhebung_ReCalculate(e.data.rowTag, SurveyRuntime.currentSurvey.erhebungRows);
                if (SurveyHooks.onRowUpdated) { SurveyHooks.onRowUpdated(e, SurveyRuntime.surveyData) }
                e.component.refresh();
                noEmployeesAvailable();
                // if (ortsgemeindeDaten) {
                //     updateOrtsgemeindedatenKontrollwerte();
                //     ortsgemeindenGrid.refresh();
                // }
            },
            onEditorPrepared: function (e) {
                SurveyRuntime.currentEditor = e.editorElement;
            },
            onRowUpdating: function (e) {
                const result = SurveyTools.validateMaximumValues(SurveyRuntime.currentSurvey.erhebungRows, e.oldData, e.newData, SurveyRuntime.currentDataField);
                if (result) {
                    SurveyTools.showErrorForGridEditor(result, SurveyRuntime.currentEditor, e);
                } else if (SurveyHooks.onRowUpdating) {
                    SurveyHooks.onRowUpdating(e, SurveyRuntime.surveyData);
                }
            },
            onEditorPreparing: function (onEditorPreparingEvent) {
                //onEditorPreparingEvent.editorOptions.showClearButton = true;
                // onEditorPreparingEvent.editorOptions.buttons = [
                //     {
                //         name: "toNull",
                //         location: "before",
                //         options: {
                //             icon: "clearcircle",
                //         }
                //     }
                // ];

                // onEditorPreparingEvent statt onValueChangedEvent ist Absicht (onValueChangedEvent.component ist der Editor (hier dxTextBox),
                // onEditorPreparingEvent.component ist ein Spalten - Objekt, das die Methode setValue hat)
                /// Eingaben validieren und ggf, korrigieren:
                //  + Alles, was sich als positive Ganzzahl auswerten lässt, wird angenommen
                //  + Die Null wird angenommen
                //  + Eventuell angegebene Nachkommawerte werden abgeschnitten(unterschätze nie die Kreativität der Anwender 😊)
                //  + Negative Werte und alle anderen Eingaben werden als Leerwert übernommen -
                const defaultValueChangeHandler = onEditorPreparingEvent.editorOptions.onValueChanged;
                onEditorPreparingEvent.editorOptions.onValueChanged = (onValueChangedEvent) => {
                    const value = onValueChangedEvent.value;
                    let numValue = null;
                    if (typeof value === "number" && Number.isFinite(value)) {
                        numValue = value;
                    } else if (typeof value === "string" && value.trim() !== "") {
                        numValue = Number(value);
                        if (!Number.isFinite(numValue)) {
                            numValue = null;
                        }
                    }
                    if (numValue !== null) {
                        if (numValue < 0) {
                            onEditorPreparingEvent.setValue(null);
                        } else if (!Number.isInteger(numValue)) {
                            onEditorPreparingEvent.setValue(Math.trunc(numValue));
                        } else {
                            onEditorPreparingEvent.setValue(numValue);
                        }
                    } else if (value == null || value === '') {
                        onEditorPreparingEvent.setValue(null);
                    }
                };
                onEditorPreparingEvent.editorOptions.onDisposing = (e) => {
                    SurveyRuntime.editorClosed();
                }
                //onEditorPreparing.editorOptions.min = 0;
/*
                if (onEditorPreparingEvent.row.rowIndex == 0 && onEditorPreparingEvent.dataField === "bs_Vollzeit") {
                    // erste Zelle: Shift-Tab zurück zu #Email
                    onEditorPreparingEvent.editorOptions.onKeyDown = (e) => {
                        const evt = e.event;
                        if (evt.key === 'Tab' && !evt.ctrlKey && evt.shiftKey && !evt.altKey) {
                            evt.stopPropagation();
                            evt.preventDefault();
                            SurveyRuntime.grids.mainGrid.grid.closeEditCell();
                            setTimeout(function () { SurveyRuntime.controls.Email.focus(); }, 100);
                        }
                    }
                }
*/
                SurveyRuntime.currentGridInstance = onEditorPreparingEvent.component;
            },
            onContentReady: function (e) {
                // Spaltenköpfe mit Umbruch werden wie gewünscht horizontal zentriert (=> setupErhebungColumns, Zuweisung an headerCellTemplate).
                // Spaltenköpfe mit Umbruch werden aber wegen der expliziten Zuweisung von "text-align: right" via style-Attribut des td-Elements
                // rechtsbundig angezeigt. Hier reparieren wir das (mit dem Holzhammer)
                if (SurveyRuntime.grids.mainGrid.fixPending) {
                    let i = 0;
                    let col = e.component.columnOption(i);
                    while (col) {
                        if (col.dataField) {
                            $("#" + col.headerId).css("text-align", "center");
                        }
                        col = e.component.columnOption(++i);
                    }
                    // tabIndex-Attribut von den Header-Zellen entfernen (dann sind sie raus aus der Tab-Order)
                    const gridElement = e.element[0];
                    const headerArea = gridElement.querySelector('.dx-datagrid-headers');
                    headerArea.querySelectorAll('[tabindex]').forEach((header) => {
                        header.removeAttribute('tabindex');
                    });
                    SurveyRuntime.grids.mainGrid.fixPending = false;
                }
                // und die annotations verlinken. Das ist jedesmal nötig, weil die Zellen bei jeder Änderung neu gerendert werden
                $("#erhebung-daten-grid .annotation").each(function (i) {
                    const id = $(this).text();
                    this.onclick = function () { SurveyTools.showAnnotation(id); }
                    this.title = "Hier klicken für weitere Informationen.";
                });
                SurveyRuntime.grids.mainGrid.annotationLinkPending = false;
                manageDeviationReasonState();
            },
            onCellPrepared(e) {
                if (e.rowType === "data") {
                    if (e.value === -1) {
                        e.cellElement.addClass("grid-cell-not-available");
                    } else {
                        if (e.column.dataType === "number") {
                            // deviationPercent: deviationPercent, previousYearValue: prevYearValue
                            const ret = SurveyRuntime.checkDeviation(e.value, e.data.rowTag, e.column.name, SurveyRuntime.surveyData.erhebungsdatenVorjahr?.erhebungRows);
                            //console.log(e.data.rowTag, e.column.name, ret);
                            //calculateDeviationDisplay(e.column, e.data.rowTag);
                            const cell = e.cellElement;
                            cell.off("mouseover");
                            if (ret) {
                                const displayInfo = calculateDeviationDisplay(e.column, e.data.rowTag);
                                if (displayInfo.cssClass) {
                                    cell.addClass(displayInfo.cssClass);
                                    cell.on("mouseover", (evtmo) => {
                                        const content = SurveyHooks.onDeviationTooltipContent ?
                                            SurveyHooks.onDeviationTooltipContent(ret) :
                                            `<div class='tooltip-content'>Vorjahr: ${ret.previousYearValue}<br/>Abweichung: ${Math.round(ret.deviationPercent)}%</div>`
                                        //console.log(content);
                                        SurveyRuntime.tooltip.option('contentTemplate', (contentElement) => {
                                            contentElement.html(content);
                                        });
                                        //console.log(evtmo);
                                        SurveyRuntime.tooltip.show(evtmo.target);
                                    })
                                }
                            } else {
                                //cell.removeClass("grid-cell-alert-deviation");
                            }
                            cell.addClass("grid-cell-default");
                        }
                    }
                }
            },
            columns: columnDef
        } // gridConfig dxDataGrid Erhebungsdaten
        if (SurveyHooks.onConfigureGrid) { SurveyHooks.onConfigureGrid(gridConfig, SurveyRuntime.currentSurvey); }
        SurveyRuntime.addGrid("mainGrid", $("#erhebung-daten-grid").dxDataGrid(gridConfig).dxDataGrid("instance")); 
/*
        if (ortsgemeindeDaten) {
            prepareOrtsgemeindeDaten(ortsgemeindeDaten);
            const ortsgemeindeColDef = [
                {
                    caption: "",
                    dataField: "bezeichnung",
                    width: "60%",
                    allowEditing: false,
                    cellTemplate(element, cellData) {
                        $('<div class="ortsgemeidedaten-col-bezeichnung-data grid-cell-multiline">')
                            .appendTo(element)
                            .html(cellData.text);
                    },
                    headerCellTemplate: ortsgemeindeHeaderCellTemplate
                },
                {
                    caption: "insgesamt",
                    dataField: "gesamt",
                    headerCellTemplate: ortsgemeindeHeaderCellTemplate,
                    validationRules: [
                        {
                            type: "custom",
                            ignoreEmptyValue: true,
                            message: 'Summe "Sozial- und Erziehungsdienst" und "BezTV-W RP" ist größer als die Gesamtzahl (Spalte "Insgesamt")',
                            validationCallback(v) {
                                return v.data.sozErzDienst + v.data.forst <= v.value;
                            }
                        }
                    ]
                },
                {
                    caption: "<u>davon</u> im Sozial- und Erziehungsdienst",
                    dataField: "sozErzDienst",
                    headerCellTemplate: ortsgemeindeHeaderCellTemplate,
                    validationRules: [
                        {
                            type: "custom",
                            ignoreEmptyValue: true,
                            message: 'Summe "Sozial- und Erziehungsdienst" und "BezTV-W RP" ist größer als die Gesamtzahl (Spalte "Insgesamt")',
                            validationCallback(v) {
                                return v.value + v.data.forst <= v.data.gesamt;
                            }
                        }
                    ]
                },
                {
                    caption: "<u>davon</u> im BezTV-W RP",
                    dataField: "forst",
                    headerCellTemplate: ortsgemeindeHeaderCellTemplate,
                    validationRules: [
                        {
                            type: "custom",
                            ignoreEmptyValue: true,
                            message: 'Summe "Sozial- und Erziehungsdienst" und "BezTV-W RP" ist größer als die Gesamtzahl (Spalte "Insgesamt")',
                            validationCallback(v) {
                                return v.data.sozErzDienst + v.value <= v.data.gesamt;
                            }
                        }
                    ]
                }
            ]
            $("#erhebung-ortsgemeindedaten").css("display", "block");
            $("#erhebung-ortsgemeindedaten-grid").dxDataGrid({
                dataSource: ortsgemeindeDaten,
                keyExpr: 'recordId',
                allowColumnResizing: false,
                allowColumnReordering: false,
                showBorders: true,
                showRowLines: true,
                showColumnLines: true,
                activeStateEnabled: true,
                rowAlternationEnabled: true,
                width: "100%",
                scrolling: {
                    showScrollbar: 'always',
                    useNative: false
                },
                sorting: { mode: "none" },
                keyboardNavigation: {
                    editOnKeyPress: true,
                    enabled: true,
                    enterKeyAction: "moveFocus",
                    enterKeyDirection: "row"
                },
                editing: {
                    allowAdding: false,
                    allowDeleting: false,
                    allowUpdating: true,
                    mode: "cell",
                    selectTextOnEditStart: true
                },
                paging: {
                    enabled: false
                },
                onCellPrepared(e) {
                    if (e.rowType === "data" && null == e.value) { // "ausgegraute" Zellen
                        e.cellElement.addClass("notAvailable");
                    }
                    if (e.data?.zeilenart && e.data.zeilenart === "T") {
                        if (ortsgemeindenKontrollwerteInfo.felder.includes(e.column.dataField)) {
                            const kontrollwert = ortsgemeindenKontrollwerteInfo.ortsgemeindenRowKontrollWerte[e.column.dataField];
                            let classname = null;
                            if (e.value != 0) {
                                if (e.value == kontrollwert) {
                                    classname = 'grid-cell-value-good'
                                } else if (e.value > kontrollwert) {
                                    classname = 'grid-cell-value-toobig'
                                } else {
                                    classname = 'grid-cell-value-toosmall'
                                }
                            }
                            if (classname) {
                                e.cellElement.addClass(classname);
                            }
                        }
                    }
                },
                onContentReady(e) {
                    ortsgemeindenGrid = e.component;
                },
                onRowUpdated(e) {
                    // Summen neu berechnen
                    ortsgemeindedatenSummenCalc()
                    e.component.refresh();
                },
                onEditingStart(e) {
                    if (e.data.zeilenart === "T" || e.data.zeilenart.length > 1 ) { // Summenzeile ist nicht editierbar, ebensowenig eingefügte Zwischenzeilen
                        e.cancel = true;
                    }
                },
                onEditorPreparing(onEditorPreparingEvent) {
                    // einige Eingaben (z.B. "e") ergeben als Wert null, wird hier auf 0 korrigiert
                    // und falls ein Schlaumi mit halben Beschäftigten rechnen will => Nachkommastellen werden abgeschnitten
                    const defaultValueChangeHandler = onEditorPreparingEvent.editorOptions.onValueChanged;
                    onEditorPreparingEvent.editorOptions.onValueChanged = (onValueChangedEvent) => {
                        const value = onValueChangedEvent.value;
                        if (value == null) {
                            onEditorPreparingEvent.setValue(0);
                            // onEditorPreparingEvent statt onValueChangedEvent ist Absicht (onValueChangedEvent.component ist der Editor (hier dxTextBox),
                            // onEditorPreparingEvent.component ist ein Spalten - Objekt, das die Methode setValue hat)
                        } else if (!Number.isInteger(value)) {
                            onEditorPreparingEvent.setValue(Math.trunc(value));
                        } else {
                            defaultValueChangeHandler(onValueChangedEvent);
                        }
                    };
                },
                columns: ortsgemeindeColDef
            }) // dxDataGrid ErhebungOrtsgemeindedaten
        }
        */
    } else {
        // Gastmitglied
        const checkNotNegative = function (e) { return isNaN(e.value) || e.value >= 0 };

        $("#erhebung-daten-gastmitglied").css("display", "grid");

        controlConfig = {
            value: SurveyRuntime.currentSurvey.gast_Angestellte,
            inputAttr: { 'aria-label': 'Beschäftigte gesamt' },
            min: 0,
            format: '#',
            onValueChanged(e) { SurveyRuntime.currentSurvey.gast_Angestellte = e.value; updateGastSumme(SurveyRuntime.currentSurvey); noEmployeesAvailable() },
        };
        controlValidatorConfig = {
            validationRules: [
                {
                    type: "custom",
                    message: "Für die Beschäftigtenzahl bitte eine Zahl gleich oder größer Null angeben.",
                    validationCallback: checkNotNegative
                }
            ]
        }
        if (SurveyHooks.onConfigureControl) { SurveyHooks.onConfigureControl('#Gast_Angestellte', 'dxNumberBox', controlConfig, controlValidatorConfig); }
        SurveyRuntime.controls['Gast_Angestellte'] = $('#Gast_Angestellte').dxNumberBox(controlConfig).dxValidator(controlValidatorConfig).dxNumberBox("instance");

        controlConfig = {
            value: SurveyRuntime.currentSurvey.gast_Azubis ?? 0,
            inputAttr: { 'aria-label': 'Auszubildende gesamt' },
            min: 0,
            format: '#',
            onValueChanged(e) { SurveyRuntime.currentSurvey.gast_Azubis = e.value; updateGastSumme(SurveyRuntime.currentSurvey); noEmployeesAvailable() },
        };
        controlValidatorConfig = {
            validationRules: [
                {
                    type: "custom",
                    message: "Für die Auszubildendenanzahl bitte eine Zahl gleich oder größer Null angeben.",
                    validationCallback: checkNotNegative
                }
            ]
        };
        if (SurveyHooks.onConfigureControl) { SurveyHooks.onConfigureControl('#Gast_Azubis', 'dxNumberBox', controlConfig, controlValidatorConfig); }
        SurveyRuntime.controls['Gast_Azubis'] = $('#Gast_Azubis').dxNumberBox(controlConfig).dxValidator(controlValidatorConfig).dxNumberBox("instance");

        controlConfig = {
            value: SurveyRuntime.currentSurvey.gast_Gesamt ?? 0,
            inputAttr: { 'aria-label': 'Beschäftigte gesamt' },
            min: 0,
            format: '#',
            readOnly: true
        };
        if (SurveyHooks.onConfigureControl) { SurveyHooks.onConfigureControl('#Gast_Gesamt', 'dxNumberBox', controlConfig, undefined); controlConfig.readOnly = true; }
        SurveyRuntime.controls['Gast_Gesamt'] = $('#Gast_Gesamt').dxNumberBox(controlConfig).dxNumberBox("instance");

    }
    controlConfig = {}
    if (SurveyHooks.onConfigureControl) { SurveyHooks.onConfigureControl('#survey-validation', 'dxValidationSummary', controlConfig, undefined); }
    // Achtung: Property heißt hier anders als die Id der div
    SurveyRuntime.controls.ValidationSummary = $('#survey-validation').dxValidationSummary(controlConfig).dxValidationSummary('instance');

    controlConfig = {
        text: 'Speichern',
        icon: 'floppy',
        type: 'success',
        onClick(e) { saveCore(e) }
    }
    if (SurveyHooks.onConfigureControl) { SurveyHooks.onConfigureControl('#survey-btn-save', 'dxButton', controlConfig, undefined); }
    // Achtung: Property heißt hier anders als die Id der div
    SurveyRuntime.controls.BtnSave = $("#survey-btn-save").dxButton(controlConfig).dxButton('instance');

    if (CONFIG.showSaveAndLogoutButton) {
        controlConfig = {
            text: 'Speichern & Logout',
            icon: 'check',
            type: 'success',
            onClick(e) { saveAndLogout(e) }
        };
        if (SurveyHooks.onConfigureControl) { SurveyHooks.onConfigureControl('#survey-btn-save', 'dxButton', controlConfig, undefined); }
        // Achtung: Property heißt hier anders als die Id der div
        SurveyRuntime.controls.BtnSaveAndLogout = $("#survey-btn-save-and-close").dxButton(controlConfig).dxButton('instance');
    }

    if (SurveyHooks.onFormCreated) { SurveyHooks.onFormCreated(SurveyRuntime.currentSurvey, SurveyRuntime.useGridMode, SurveyRuntime.controls) }
    manageDeviationReasonState();
}
function setupErhebungColumns(columnDef) {
    // Achtung: dieser Code geht von Annahmen über die Konfiguration aus:
    // Matrix.ShortNameHeading = true bei der Generierung
    // 1. Spalte => ShortName
    // 2. Spalte => Label
    // alle anderen: Beschäftigenzahlen
    
    let column = columnDef[0].columns[0].columns[0] // Nr.
    column.width = 35;

    column = columnDef[0].columns[1].columns[0] // Sparte
    column.width = 225;
    column.cellTemplate = function (element, info) {    // Spalte Sparte mit Umbruch in den Zellen
        $("<div>")
            .appendTo(element)
            .html('<div class="erhebung-col-sparte">' + info.value + '</div>')
            .css("width", info.column.width - 10) 
            .css("height", "auto")
            .css("white-space", "normal")
            .css("overflow-wrap", 'break-word');
    }

    for (let i = 0; i < columnDef.length; i++) {
        const group = columnDef[i];  // Gruppen
        group.alignment = "center";  // Ausrichtung Gruppe-Kopf
        group.headerCellTemplate = function (element, info) {
            $('<div>')
                .appendTo(element)
                .text(group.caption)
                .css("font-weight", "bold");
        } 

        
        for (const shortname of group.columns) {
            shortname.alignment = "center";   //  A, B, C, D, E, ...
            const column = shortname.columns[0];    // die eigentlichen Spalten
           
            if (column.mwitc && column.mwitc.widthHint) { // das sind die Spalten ab C
                let extra = 0;
                if (column.mwitc.widthHint >= -1) {
                    extra = column.mwitc.widthHint * 15;
                }
                column.width = 85 + extra;
            }
            if (i > 1) {
                column.alignment = "right";
            }
            let src = '<div class="erhebung-col-head">' + column.caption
            if (column.mwitc && column.mwitc.annotationId) {
                src += '<sup class="annotation">' + column.mwitc.annotationId + '</sup>';
            }
            src += '</div>'
            column.headerCellTemplate = function (element, info) {
                $('<div>')
                    .appendTo(element)
                    .html(src)
                    .css("text-align", "center")
                    .css("width", "100%")
                    .css("display", "table-cell")
                    .css("height", "auto")
                    .css("white-space", "normal")
                    .css("overflow-wrap", 'break-word');
                
            } 
        }
    }
}
function saveAndLogout(event) {
    saveCore(event, true);
}
export function save(event) {
    return saveCore(event, false);
}

async function saveCore(event, logout) {
    if (SurveyRuntime.useGridMode) { 
        await SurveyRuntime.grids.mainGrid.grid.saveEditData(); // sonst wird evtl. nicht gespeichert...
    }
    if (SurveyHooks.onSaveEditors) { SurveyHooks.onSaveEditors(SurveyRuntime.currentSurvey, SurveyRuntime.useGridMode); }
    
    //if (ortsgemeindeDaten) {
    //    await ortsgemeindenGrid.saveEditData();
    //}
    let result = event.validationGroup.validate();
    const errors = [];
    if (SurveyHooks.onSaveValidate) { SurveyHooks.onSaveValidate(SurveyRuntime.currentSurvey, SurveyRuntime.useGridMode, errors); }
    // if (ortsgemeindeDaten) {
    //     // Summen OG gegen PBE Summen prüfen
    //     updateOrtsgemeindedatenKontrollwerte();
    //     if (ortsgemeindenKontrollwerteInfo.ortsgemeindenRowSummen.gesamt != ortsgemeindenKontrollwerteInfo.erhebungRowGesamt.gesamtsumme) {
    //         errors.push("Gesamtzahl der Beschäftigten und Auszubildenden in der Personalbestandserhebung stimmt nicht mit der Gesamtzahl der Beschäftigten und Auszubildenden der Ortsgemeinden und der Verbandsgemeinde überein.");
    //     }
    //     if (ortsgemeindenKontrollwerteInfo.ortsgemeindenRowSummen.forst != ortsgemeindenKontrollwerteInfo.erhebungRowForst.gesamtsumme) {
    //         errors.push("Gesamtzahl der Beschäftigten und Auszubildenden BezTV-W RP in der Personalbestandserhebung stimmt nicht mit der Gesamtzahl der Beschäftigten und Auszubildenden BezTV-W RP der Ortsgemeinden und der Verbandsgemeinde überein.");
    //     }
    //     SurveyRuntime.controls.CustomValidationSummary.option("items", errors);
    // }
    if (result.isValid && errors.length == 0) {
        const info = window.CONFIG.surveyHelper.Erhebung_Info;
        let total = 0;
        if (SurveyRuntime.useGridMode) {
            total = SurveyRuntime.currentSurvey.erhebungRows[info.totalRowPosition][info.totalColumnField] ?? 0;
        } else {
            total = SurveyRuntime.currentSurvey.gast_Gesamt ?? 0;
        }

        const daten = {
            Erhebungsdaten: SurveyRuntime.currentSurvey 
            //erhebungOrtsgemeindedaten: null
        }
        if (SurveyHooks.onSavePrepareResponse) { SurveyHooks.onSavePrepareResponse(daten, SurveyRuntime.useGridMode); }
        //if (ortsgemeindeDaten) {
        //    daten.erhebungOrtsgemeindedaten = ortsgemeindeDaten.filter(r => r.zeilenart.length == 1);
        //}
        const saveAction = function () { saveExecute(daten, logout); }
        if (SurveyHooks.onBeforeSave) {
            SurveyHooks.onBeforeSave(daten, saveAction);
        }
        let dlg = null;

        if (total == 0 && CONFIG.askIfZero) {
            if (CONFIG.useNoEmployees) {
                if (!SurveyRuntime.currentSurvey.keineBeschaeftigten) {
                    DevExpress.ui.dialog.alert('Wenn es wirklich <b>keine</b> zu meldenden Beschäftigten gibt, dann aktivieren Sie bitte das Kontrollkästchen <b>"Keine Beschäftigten"</b>.', 'Eingabe korrigieren');
                    dlg = 1;
                }
            } else {
                dlg = DevExpress.ui.dialog.confirm("Gibt es wirklich <b>keine</b> zu meldenden Beschäftigten? ", "Bitte bestätigen Sie!");
            }
        }
        if (dlg) {
            dlg.done(function (dialogResult) {
                if (dialogResult) {
                    saveAction();
                }
            });
        } else {
            saveAction();
        }
    }
}
function saveExecute(daten, logout) {
    daten.clientVersion = CONFIG.clientVersion;
    const url = new URL(window.CONFIG.serverApi + "/daten");
    // if (!SurveyRuntime.existsRelevantDeviation) {
    //     daten.Erhebungsdaten.GrundAbweichung = null;
    // }
    const request = {
        cache: false,
        url: url,
        contentType: 'application/json',
        method: 'PUT',
        headers: window.CONFIG.customHeaders,
        data: JSON.stringify(daten),
        success: function (response) {
            SurveyRuntime.currentSurvey = response;
            if (SurveyRuntime.useGridMode) {
                const rows = SurveyRuntime.currentSurvey.erhebungRows;
                CONFIG.surveyHelper.Erhebung_PrepareRows(rows);
                rows.forEach((row) => {
                    if (row.annotationId) {
                        row.label += '<sup class="annotation">' + row.annotationId + '</sup>';
                    }
                });
                SurveyRuntime.grids.mainGrid.grid.option('dataSource', SurveyRuntime.currentSurvey.erhebungRows); // refresh
            } else {
                // Todo: gast_Gesamt Anzeige aktualisieren
            }
            // die anderen Editoren müssen nicht aktualisiert werden, hier finden keine Korrekturen durch den WebService statt
            // emailEditor.option('value', erhebungDaten.Email);
            if (SurveyHooks.onRefreshAfterSave) { SurveyHooks.onRefreshAfterSave(SurveyRuntime.currentSurvey, SurveyRuntime.useGridMode); }
            updateFooter();
            if (logout) {
                let dlg = DevExpress.ui.dialog.confirm("Wollen Sie eine Kopie der angegebenen Mitarbeiterzahlen als PDF-Datei speichern?", "Beleg-Kopie erstellen");
                dlg.done(function (dialogResult) {
                    (dialogResult ? SurveyPdf.ExportToPdf(SurveyRuntime.grids.mainGrid.grid, SurveyRuntime.currentSurvey, SurveyRuntime.mitgliedNummer) /*exportToPdf()*/ : Promise.resolve()).
                        then(() => {
                            SurveyTools.logout();
                            if (dialogResult) {
                                // das Erzeugen der PDF-Datei erfolgt asynchron, und ich habe es nicht geschafft, darauf zu warten. Deshalb diese Krücke...
                                DevExpress.ui.dialog.alert("Sie wurden abgemeldet.", "Personalbestandserhebung Online").done(() => location.reload());
                            } else {
                                location.reload();
                            }
                        });
                });
            } else {
                let direction = 'up-push';
                let position = 'bottom center';
                DevExpress.ui.notify({
                    message: "Erhebungsdaten wurden gespeichert.",
                    height: 60,
                    width: 400,
                    minWidth: 400,
                    displayTime: 5000,
                    closeOnClick: true,
                    hideOnOutsideClick: true,
                    type: "success"
                },
                    {
                        position,
                        direction
                    });
            }
        },
        error: function (jqXHR) {
            console.error(jqXHR)
            SurveyTools.showRequestErrorInDialog("Fehler beim Speichern der Personalbestandserhebung", jqXHR, SurveyRuntime.controls.ValidationSummary);
        }
    };
    return $.ajax(request);

}

function updateGastSumme(erhebungDaten) {
    if (erhebungDaten.gast_Angestellte === null && erhebungDaten.gast_Azubis === null) {
        erhebungDaten.gast_Gesamt = null;
    } else {
        erhebungDaten.gast_Gesamt = (erhebungDaten.gast_Angestellte ?? 0) + (erhebungDaten.gast_Azubis ?? 0);
    }
    // Anzeige aktualisieren
    SurveyRuntime.controls.Gast_Gesamt.option("value", erhebungDaten.gast_Gesamt);
}

function updateFooter() {
    if (CONFIG.useStandardFooter) {
        let msg = "";
        if (SurveyRuntime.currentSurvey.datum) {
            msg = `zuletzt bearbeitet am ${new Date(SurveyRuntime.currentSurvey.datum).toLocaleString("de-de", { timeStyle: "medium", dateStyle: "medium" })}`;
        }
        $("#common-foot-info").html(msg);
    }
}

function setupDeviationStuff(erhebungsdatenResponse) {
    if (erhebungsdatenResponse.deviationThresholdPercent > 0) {
        SurveyRuntime.deviationCheckEnabled = true;
        const percent = erhebungsdatenResponse.deviationThresholdPercent;
        const min = erhebungsdatenResponse.deviationThresholdMinimumValue;
        //const prevYearRows = SurveyRuntime.surveyData.erhebungsdatenVorjahr?.erhebungRows;
        //console.log("Deviation check enabled: percent=" + percent + ", min=" + min);
        SurveyRuntime.checkDeviation = function (value, rowTag, columnName, prevYearRows) {
            if (null == prevYearRows || value == null) return false;
            const prevYearRow = prevYearRows.find(e => e.rowTag === rowTag);
            if (prevYearRow && prevYearRow[columnName]) {
                const prevYearValue = prevYearRow[columnName];
                if (prevYearValue >= min || value >= min) {
                    const deviation = (value - prevYearValue);
                    const deviationPercent = deviation / prevYearValue * 100.0;
                    if (Math.abs(deviationPercent) >= percent) {
                        return { deviationPercent: deviationPercent, previousYearValue: prevYearValue };
                    }
                }
            }
            return false;
        }
    } else {
        SurveyRuntime.checkDeviation = () => false;
    }
}
function existsRelevantDeviation() {
    //return $("#erhebung-daten-grid td").hasClass("grid-totalcell-alert-deviation");
    //return $("#erhebung-daten-grid td").find(".grid-editcell-alert-deviation, .grid-sumcell-alert-deviation, .grid-totalcell-alert-deviation").length > 0;
    return $("#erhebung-daten-grid td")
        .filter(".grid-editcell-alert-deviation, .grid-sumcell-alert-deviation, .grid-totalcell-alert-deviation")
        .length > 0
}
function manageDeviationReasonState() {
    if (existsRelevantDeviation()) {
        $(SurveyRuntime.deviationReasonAreaId).show().toggleClass("deviation-reason-no-data", !SurveyRuntime.currentSurvey.grundAbweichung);
    } else {
        $(SurveyRuntime.deviationReasonAreaId).hide()
    }
}
function calculateDeviationDisplay(column, rowTag) {
    const ret = {cssClass: null, isSum: false, isTotal: false};
    ret.isSum = !column.allowEditing || CONFIG.surveyHelper.Erhebung_Info.sumRows.includes(rowTag); // Summenspalte oder -zeile
    if (ret.isSum) {
        ret.isTotal = (rowTag == SurveyRuntime.totalRowTag && column.name == SurveyRuntime.totalColumnDataField)
        if (ret.isTotal) {
            ret.cssClass = "grid-totalcell-alert-deviation";
        } else if (CONFIG.deviationCheck.tagSums) { // Summe
            ret.cssClass = "grid-sumcell-alert-deviation";
        }
    } else { // editierbare Zelle
        if (CONFIG.deviationCheck.tagEditors) {
            ret.cssClass = "grid-editcell-alert-deviation";
        }
    }
    return ret;    
}
function noEmployeesState(set) {
    if (SurveyRuntime.useGridMode) {
        SurveyRuntime.grids.mainGrid.grid.option("visible", !set);
    } else {
        $("#field-Gast_Angestellte").toggle(!set);
        $("#field-Gast_Azubis").toggle(!set);
        $("#field-Gast_Gesamt").toggle(!set);
    }
}
function getTotalSum() {
    return SurveyRuntime.useGridMode ? SurveyRuntime.currentSurvey.erhebungRows.slice(-1)[0].gesamtsumme : SurveyRuntime.currentSurvey.gast_Gesamt;
}
function noEmployeesAvailable() {
    // prüfen, ob irgendeine Beschäftigtenzahl > 0 ist. Wenn ja, dann ist die Checkbox "aktuell gibt es keine Beschäftigten" nicht verfügbar
    if (!CONFIG.useNoEmployees) return;
    const total = getTotalSum() ?? 0;
    if (total == 0) {
        if (!CONFIG.noEmployeesAvailable) {
            SurveyRuntime.controls.keineBeschaeftigte.option("disabled", false);
            CONFIG.noEmployeesAvailable = true;
            // hier keinen Wert setzen: das Anhaken der Checkbox "aktuell gibt es keine Beschäftigten" ist eine bewusste Entscheidung des Anwenders
        }
    } else {
        if (CONFIG.noEmployeesAvailable) {
            SurveyRuntime.controls.keineBeschaeftigte.option("disabled", true);
            SurveyRuntime.controls.keineBeschaeftigte.option("value", false);
            CONFIG.noEmployeesAvailable = false;
        }
    }
}

export function exportToPdf() {
    // Promise
    return SurveyPdf.ExportToPdf(SurveyRuntime.grids.mainGrid.grid, SurveyRuntime.currentSurvey, SurveyRuntime.mitgliedNummer);
}

// function ortsgemeindeHeaderCellTemplate (element, columnData) {
//     $('<div class="ortsgemeidedaten-headers grid-cell-multiline">')
//         .appendTo(element)
//         .html(columnData.column.caption);
// } 
// function prepareOrtsgemeindeDaten(ortsgemeindeDaten) {
//     ortsgemeindeDaten[0].bezeichnung = '<span class="ortsgemeinde-headline-in-data">Beschäftigte und Auszubildende <u>nur</u> der Verbandsgemeinde</span>';
//     const ortsgemeindeHeader = {
//         bezeichnung: '<span class="ortsgemeinde-headline-in-data">Beschäftigte und Auszubildende der Ortsgemeinden</span><br/>(Hier sind <u><b>alle</b></u> Ortsgemeinden aufzuführen, auch wenn eine Ortsgemeinde die Mitgliedschaft zu unserem Verband nicht besitzt. <b>Beschäftigte von Zweckverbänden sind nicht aufzuführen.</b>)',
//         zeilenart: 'A1',
//         recordId: 'A1' 
//     }
//     ortsgemeindeDaten.splice(1, 0, ortsgemeindeHeader);
//     const sumRow = ortsgemeindeDaten.at(-1);
//     sumRow.bezeichnung = '<span class="ortsgemeinde-headline-in-data">' + sumRow.bezeichnung + '</span>';
//     const kontrollWerte = {
//         bezeichnung: 'Kontrollwerte (aus Spalte <b>P</b> der Personalbestandserhebung)',
//         zeilenart: 'T1',
//         recordId: 'T1'
//     }
//     ortsgemeindeDaten.push(kontrollWerte);
//     ortsgemeindenKontrollwerteInfo = {
//         ortsgemeindenRowKontrollWerte: kontrollWerte,
//         ortsgemeindenRowSummen: ortsgemeindeDaten.at(-2),
//         felder: ["gesamt", "forst"],
//         erhebungRowForst: erhebungDaten.erhebungRows.find(r => r.rowTag === 'Wald'),
//         erhebungRowGesamt: erhebungDaten.erhebungRows.find(r => r.rowTag === 'Gesamt')

//     }
//     updateOrtsgemeindedatenKontrollwerte();
// }
// function updateOrtsgemeindedatenKontrollwerte() {
//     ortsgemeindenKontrollwerteInfo.ortsgemeindenRowKontrollWerte.forst = ortsgemeindenKontrollwerteInfo.erhebungRowForst?.gesamtsumme;
//     ortsgemeindenKontrollwerteInfo.ortsgemeindenRowKontrollWerte.gesamt = ortsgemeindenKontrollwerteInfo.erhebungRowGesamt?.gesamtsumme;
// }
// function ortsgemeindedatenSummenCalc() {
//     const accumulator = {
//         gesamt: 0,
//         sozErzDienst: 0,
//         forst: 0
//     }
//     const gesamt = ortsgemeindeDaten.filter(r => r.zeilenart == "A" || r.zeilenart == "D").reduce(
//         (acc, r) => {
//             acc.gesamt += r.gesamt;
//             acc.sozErzDienst += r.sozErzDienst;
//             acc.forst += r.forst;
//             return acc;
//         }, accumulator);
//     const sumRow = ortsgemeindenKontrollwerteInfo.ortsgemeindenRowSummen;
//     sumRow.gesamt = accumulator.gesamt;
//     sumRow.sozErzDienst = accumulator.sozErzDienst;
//     sumRow.forst = accumulator.forst;
// }